import axios, { baseURL } from "utils/api";

export const getServiceReviews = (params) => axios.get(`${baseURL}/service-reviews`, { params });
export const getServiceReviewRules = () => axios.get(`${baseURL}/service-reviews/rules`);
export const updateServiceReviewRule = (id, data) => axios.patch(`${baseURL}/service-reviews/rules/${id}`, data);
export const updateServiceReview = (id, data) => axios.patch(`${baseURL}/service-reviews/${id}`, data);
export const getServiceReviewIncidents = (id) => axios.get(`${baseURL}/service-reviews/${id}/incidents`);
